import styled from 'styled-components';

import { Color } from '.';

export const TabMenuItem = styled.div<{
  isActive: boolean;
  colors?: Color;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme, colors }) =>
    colors?.passiveTextColor || theme.palette.grey1100};

  height: 54px;
  padding: 14px 14px 12px 14px;

  ${({ isActive, colors, theme }) =>
    isActive &&
    `border-bottom: 1px solid ${theme.palette.primaryBrand};
     color: ${colors?.activeTextColor || theme.palette.primaryBrand};
    `};

  :hover {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.primaryBrand};
  }
`;

export const IconWrapper = styled.div<{ $rotate?: boolean }>`
  margin-top: 0;
  margin-right: 8px;
  transform: ${({ $rotate }) => ($rotate ? 'rotate(45deg)' : 'none')};

  svg {
    fill: ${({ theme }) => theme.palette.primaryBrandDark};
  }
`;

export const TextWrapper = styled.div``;
